import { render, staticRenderFns } from "./edit_platform.vue?vue&type=template&id=51cfd3c3&scoped=true"
import script from "./edit_platform.vue?vue&type=script&lang=js"
export * from "./edit_platform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cfd3c3",
  null
  
)

export default component.exports